<!-- search input-->
<div class="w-full h-12 px-3 py-4 bg-white rounded-md  border border-gray-300 justify-start items-center flex mb-2">
  <div class="w-5 h-5 relative"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="&#240;&#159;&#147;&#141;Trailing Icon">
        <path id=" &#226;&#134;&#179;Color" fill-rule="evenodd" clip-rule="evenodd"
          d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
          fill="black" fill-opacity="0.6" />
      </g>
    </svg>
  </div>

  <input [formControl]="searchFlight" (focus)="searchFieldFocused=!searchFieldFocused"
    (blur)="searchFieldFocused=!searchFieldFocused"
    placeholder="{{'PARKIFLY.DATE_AND_FLIGHT_PICKER.SEARCH_FLIGHT' | transloco}}"
    class="grow shrink basis-0 border-transparent bg-transparent focus:border-transparent focus:ring-0  !outline-none h-[23px] text-black text-sm font-medium leading-tight" />
</div>

<!--Search results-->
<div class="
            SearchResultWrapper 
            h-full
            min-h-[300px]
            max-h-[60vh]
            md:min-h-96 
            md:max-h-96  
            py-2 bg-white rounded-xl flex-col justify-start items-start inline-flex 
            overflow-y-auto
            w-full
            " cdkVirtualScrollingElement>

  <cdk-virtual-scroll-viewport itemSize={{itemSize}} class="h-full w-full min-h-[300px]">
    <pf-flight-option [isSelected]="selectedIndex == index" (click)="onSelect(index)" [destination]="flight.flightId"
      (click)="setSelectedFlight(flight)" *cdkVirtualFor="let flight of flightList;
              let index = index
              " class="w-full  block last:border-none  border-b border-black  border-opacity-10" [flightInfo]="flight"
      [time]="getFlightTimeByType(flight).scheduled" [codeshares]="flight.codeShareData"
      [destination]="type === 'departure' ? flight.arrivalAirportSwedish : flight.departureAirportSwedish">
    </pf-flight-option>
  </cdk-virtual-scroll-viewport>

</div>